import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CerrixTextInputBase } from "../components/cerrix-textinput/cerrix-textinput-base";
import { AiSuggestionsPopupComponent } from "../ai-suggestions-popup/ai-suggestions-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AiSettingsService } from "@app/ai/services/ai-settings-data.service";
import {
    injectTranslation,
    provideTranslationScope,
    TranslatePipe,
} from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { firstValueFrom } from "rxjs";
import { InputTooltipDirective } from "../directives/input-tooltip.directive";
import { TextAreaAutoGrowDirective } from "../directives/textarea-auto-grow";

@Component({
    selector: "ai-description-generator",
    templateUrl: "./ai-description-generator.component.html",
    styleUrls: ["./ai-description-generator.component.scss"],
    imports: [FormsModule, TranslatePipe, InputTooltipDirective, TextAreaAutoGrowDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class AiDescriptionGeneratorComponent extends CerrixTextInputBase implements OnInit {
    @Input() fetchDescriptionsDatamethod: () => Promise<string[]>;
    @Input() rows = 3;
    @Input() autoGrowEnabled = false;

    @Output() onDescriptionGenerated = new EventEmitter<string>();

    generateDescriptionButtonDisabled: boolean = false;
    generateDescriptionButtonIcon: string;

    aiAssistanceEnabled: boolean = false;

    private _aiSettingsService = inject(AiSettingsService);
    private _toastr = inject(ToastrService);
    private _dialog = inject(MatDialog);
    private _translation = injectTranslation(scope);

    public constructor() {
        super();
        this.control.valueAccessor = this;
        this.multiline = true;
    }

    async ngOnInit(): Promise<void> {
        super.init();

        const isEnabled = await firstValueFrom(this._aiSettingsService.isEnabled());

        this.aiAssistanceEnabled = isEnabled;

        if (this.aiAssistanceEnabled) {
            this.enableDescriptionGeneratorButton();
        }
    }

    async generateDescription(): Promise<void> {
        if (!this.value || this.value.length === 0) {
            await this._translation.ready();
            this._toastr.warning(this._translation.t("enterDescriptionFirst"));
            return;
        }

        try {
            this.disableDescriptionGeneratorButton();

            var suggestions = await this.fetchDescriptionsDatamethod();

            this._dialog.open(AiSuggestionsPopupComponent, {
                data: {
                    suggestions: suggestions,
                    onConfirm: ((suggestion: string) => {
                        this.onDescriptionGenerated.emit(suggestion);
                    }).bind(this),
                },
                panelClass: "ai-suggestions-popup",
                width: "700px",
            });
        } finally {
            this.enableDescriptionGeneratorButton();
        }
    }

    private enableDescriptionGeneratorButton(): void {
        this.generateDescriptionButtonDisabled = false;
        this.generateDescriptionButtonIcon = "fas fa-wand-magic-sparkles";
    }

    private disableDescriptionGeneratorButton(): void {
        this.generateDescriptionButtonDisabled = true;
        this.generateDescriptionButtonIcon = "fas fa-hourglass-start";
    }
}
